import * as T from "./frontendTypes";

/**
 * Build a stable map of `SowItem.itemId` -> 1-based action item number.
 *
 * Numbering is derived from the SoW's action items sorted by `itemDate`
 * ascending — the same order every SoW/invoice view renders in — so a given
 * action item shows the same "Item #" on the SoW and on every invoice that
 * references it. Payment rows (milestone / final / co-invest) are never
 * numbered, so they are not included here.
 *
 * Derived rather than persisted: no schema change, no migration, and the
 * number stays consistent across views as long as they share this helper.
 */
export const buildActionItemNumbers = (
  sowItems: T.SowItem[]
): Map<string, number> => {
  const map = new Map<string, number>();
  [...(sowItems || [])]
    .sort((a, b) => new Date(a.itemDate).getTime() - new Date(b.itemDate).getTime())
    .forEach((item, idx) => {
      if (item.itemId) map.set(item.itemId, idx + 1);
    });
  return map;
};
